import { render, staticRenderFns } from "./LayoutTesting.vue?vue&type=template&id=5a5bf918&"
import script from "./LayoutTesting.vue?vue&type=script&lang=js&"
export * from "./LayoutTesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports